//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    containers: [],
    searchRequest: null,
  },
  mutations: {
    updateCcicContainers(state, containers) {
      state.containers = containers;
    },
    updateSearchCcicContainerRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadCcicContainers({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));
//***********************************************************************
//local time and date

      if (requestToSend.localSearch.startDate)
      {
          const date = moment(requestToSend.localSearch.startDate)
                      .endOf('d')
                      .toDate();
          console.log(date)
          console.log(date.getMonth())
          console.log(date.getDate())
          var month = (date.getMonth() + 1).toString()
          if (month.length === 1)
          {
              month = '0' + month
          }
  
          var day = date.getDate().toString()
          if (day.length === 1)
          {
              day = '0' + day
          }
  
          requestToSend.localSearch.startDate = date.getFullYear() + '-' + month + '-' + day + 'T00:00:00'
      }
      
  
      if (requestToSend.localSearch.endDate)
      {
          const date = moment(requestToSend.localSearch.endDate)
                      .endOf('d')
                      .toDate();
  
                      var month = (date.getMonth() + 1).toString()
                      if (month.length == 1)
                      {
                          month = '0' + month
                      }
              
                      var day = date.getDate().toString()
                      if (day.length == 1)
                      {
                          day = '0' + day
                      }
          requestToSend.localSearch.endDate = date.getFullYear() + '-' + month + '-' + day + 'T23:59:59'
      }
      else
      {

        
          const date = moment(requestToSend.localSearch.startDate)
                      .endOf('d')
                      .toDate();
          console.log(date)
          console.log(date.getMonth())
          console.log(date.getDate())
          var month = (date.getMonth() + 1).toString()
          if (month.length === 1)
          {
              month = '0' + month
          }
  
          var day = date.getDate().toString()
          if (day.length === 1)
          {
              day = '0' + day
          }
  
          requestToSend.localSearch.endDate = date.getFullYear() + '-' + month + '-' + day + 'T23:59:59'
          
          if (!requestToSend.localSearch.startDate)
          {
            requestToSend.localSearch.endDate = null
          }
      
        }








      if (requestToSend.ccicDate.endDate) {
        requestToSend.ccicDate.endDate = moment(requestToSend.ccicDate.endDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.cargoCutoffDate.endDate) {
        requestToSend.cargoCutoffDate.endDate = moment(requestToSend.cargoCutoffDate.endDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.containerCreateDate.endDate) {
        requestToSend.containerCreateDate.endDate = moment(requestToSend.containerCreateDate.endDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.sealUpdateDate.endDate) {
        requestToSend.sealUpdateDate.endDate = moment(requestToSend.sealUpdateDate.endDate)
          .endOf('d')
          .toDate();
      }

      if (requestToSend.ccicDate.startDate && !requestToSend.ccicDate.endDate) {
        requestToSend.ccicDate.endDate = moment(requestToSend.ccicDate.startDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.cargoCutoffDate.startDate && !requestToSend.cargoCutoffDate.endDate) {
        requestToSend.cargoCutoffDate.endDate = moment(requestToSend.cargoCutoffDate.startDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.containerCreateDate.startDate && !requestToSend.containerCreateDate.endDate) {
        requestToSend.containerCreateDate.endDate = moment(requestToSend.containerCreateDate.startDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.sealUpdateDate.startDate && !requestToSend.sealUpdateDate.endDate) {
        requestToSend.sealUpdateDate.endDate = moment(requestToSend.sealUpdateDate.startDate)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.users.length === 0 && requestToSend.usersInTeam && requestToSend.usersInTeam.length > 0) {
        requestToSend.users = requestToSend.usersInTeam;
      }

      const st = performance.now();
      let resultList = [];
      //let result = await api.post('/api/w/ccic/container/search', requestToSend);
      let result = await newAPIPost('/api/w/ccic/container/search', requestToSend);
      resultList = resultList.concat(result.list);
      while (result.lastEvaluatedKey) {
        requestToSend.lastEvaluatedKey = result.lastEvaluatedKey;
        /* eslint-disable no-await-in-loop */
        //result = await api.post('/api/w/ccic/container/search', requestToSend);
        result = await newAPIPost('/api/w/ccic/container/search', requestToSend);
        resultList = resultList.concat(result.list);
      }

      console.log(`${parseInt(performance.now() - st, 0)}ms searching containers`);

      commit('updateSearchCcicContainerRequest', fallbackRequest);
      return commit('updateCcicContainers', resultList);
    },
  },
  getters: {
    getCcicContainers: state => state.containers,
  },
};
